/**
 * Gate 1 — Step 6: Test Suites REST client.
 */
import axios from "axios";
import { API_BASE_URL } from "../config";

const base = (projectId) => `${API_BASE_URL}/projects/${projectId}/gate1/test-suites`;

export async function fetchTestSuites(projectId) {
  const res = await axios.get(base(projectId));
  return res.data;
}

export async function createTestSuite(projectId, suite) {
  const res = await axios.post(`${base(projectId)}/suites`, suite);
  return res.data;
}

export async function updateTestSuite(projectId, suiteId, patch) {
  const res = await axios.put(`${base(projectId)}/suites/${suiteId}`, patch);
  return res.data;
}

export async function deleteTestSuite(projectId, suiteId) {
  const res = await axios.delete(`${base(projectId)}/suites/${suiteId}`);
  return res.data;
}

export async function removeTestSuiteCase(projectId, suiteId, testCaseId) {
  const res = await axios.delete(`${base(projectId)}/suites/${suiteId}/cases/${testCaseId}`);
  return res.data;
}
